// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__1PETO","title":"style_title__1rvYk","form":"style_form__3I7v4","input":"style_input__3XMl-"};